module.exports = __webpack_public_path__ + "img/ico-bibli-midnight.7ce2b37e.svg";